export default __webpack_public_path__ + "static/media/gallery - original vs translated_05.b3d9c7d8.jpg";